import { Link } from 'react-router-dom';

/**
 * Where an SSO callback sends someone whose account has not been approved.
 *
 * Deliberately a plain public route with no session behind it — a pending
 * account holds no cookie, which is the whole point of the approval gate.
 */
export default function AccountPending() {
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center sm:px-6 lg:py-28">
      <span className="inline-grid h-14 w-14 place-items-center rounded-full bg-gold-100 text-gold-600">
        <svg aria-hidden viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="1.7">
          <circle cx="12" cy="12" r="8.75" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5V12l2.75 1.75" />
        </svg>
      </span>

      <h1 className="mt-7 font-display text-2xl font-semibold tracking-tight text-ink-900">
        Your account is awaiting approval
      </h1>

      <p className="mt-4 text-ink-500">
        Thanks for signing in. You'll receive an email as soon as your account is ready.
      </p>

      <p className="mt-6 text-sm text-ink-500">
        For any enquiries, contact{' '}
        <a
          href="mailto:office@fttmy.org"
          className="font-medium text-gold-600 underline-offset-2 hover:underline"
        >
          office@fttmy.org
        </a>
      </p>

      <Link
        to="/"
        className="mt-9 inline-flex rounded-lg bg-ink-800 px-6 py-3 text-base font-medium text-white transition-colors hover:bg-ink-900"
      >
        Back to the site
      </Link>
    </div>
  );
}
